// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"5c2958d6","244":"2a3cc92d","340":"9113f386","504":"72f1b849","642":"5001c01b","888":"e5e4b7ad","900":"746bca13","948":"f67f6174","992":"79b3e133"}[chunkId] + ".chunk.js";
};